import { GET_WELLNESS_PLAN_CATALOG } from "./catalog-items.query";
import { IWellnessPlanCatalogItem, IWellnessPlanCatalogResponse } from "./catalog-items.interface";
import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

export const useWellnessPlanCatalog = () => {
  const [getWellnessPlanCatalog, { data, loading, error, called }] =
    useLazyQuery<{ getWellnessPlanCatalog: IWellnessPlanCatalogResponse }>(
      GET_WELLNESS_PLAN_CATALOG,
      { fetchPolicy: "network-only" },
    );

  const fetchCatalogItems = useCallback((petId: string) => {
    getWellnessPlanCatalog({
      variables: { petId },
    });
  }, [getWellnessPlanCatalog]);

  const catalogPlans: IWellnessPlanCatalogItem[] | undefined =
    data?.getWellnessPlanCatalog?.plans;

  return {
    fetchCatalogItems,
    catalogPlans,
    loading,
    error,
    called,
  };
};


export const useCatalogItems = useWellnessPlanCatalog;
